import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/apiClient";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Loader2, ScrollText } from "lucide-react";

export default function AuditLogs() {
  const { t } = useTranslation();
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/audit-logs").then((r) => setLogs(r.data)); }, []);

  if (!logs)
    return <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-blue-600" /></div>;

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <h1 className="font-heading text-3xl font-black text-slate-900">{t("audit.title")}</h1>
        <p className="mt-1 text-slate-500">{t("audit.events", { count: logs.length })}</p>
      </div>
      <Card className="divide-y divide-slate-200 border-slate-200 bg-white shadow-sm">
        {logs.map((l, i) => (
          <div key={i} data-testid={`audit-row-${i}`} className="flex flex-wrap items-center justify-between gap-2 p-4">
            <div className="flex items-center gap-3">
              <ScrollText className="h-4 w-4 text-slate-400" />
              <div>
                <div className="font-medium text-slate-900">{l.action}</div>
                <div className="text-xs text-slate-500">{l.actor_email} · {l.actor_role}</div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              {Object.keys(l.details || {}).length > 0 && (
                <Badge className="border-0 bg-slate-100 text-xs text-slate-600">{JSON.stringify(l.details).slice(0, 60)}</Badge>
              )}
              <span className="text-xs text-slate-400">{new Date(l.created_at).toLocaleString()}</span>
            </div>
          </div>
        ))}
      </Card>
    </div>
  );
}
